import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";

const DaajiMessageAudio = ({ homeProp, eventInfo }) => {
  const [modalShow, setModalShow] = React.useState(false);
  const [audioLink, setAudioLink] = React.useState("");

  if (homeProp && eventInfo.length < 1) {
    return null;
  }

  const playAudio = (language) => {
    setModalShow(true);
    const link =
      eventInfo?.find((item) => item?.language === language)?.link || "#";
    // setVideoType(type);
    setAudioLink(link);
  };

  return (
    <>
      <div className="daaji_wrrapper shade-bg">
        <div className="container">
          {eventInfo.length > 0 && (
            <div className="daaji_box">
              <h2 className="message-sub-heading">
                <span>Audio</span>
              </h2>
              <h6 className="mb-4">
                Choose your Language:
                <br />
              </h6>
              {eventInfo.map((item) => (
                <div className="col-sm-6 col-md-3">
                  <div
                    role="button"
                    tabIndex={0}
                    className="message-contents"
                    onClick={() => {
                      playAudio(item.language);
                    }}
                    onKeyDown={() => {
                      playAudio(item.language);
                    }}
                  >
                    {item.language}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="modal-90w"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Daaji&apos;s Message
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="video">
            <audio controls>
              <source src={audioLink} type="audio/mpeg" />
              <track kind="captions" srcLang="en" label="english_captions" />
            </audio>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

DaajiMessageAudio.propTypes = {
  homeProp: PropTypes.bool,
  eventInfo: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      language: PropTypes.string,
    })
  ),
};

DaajiMessageAudio.defaultProps = {
  homeProp: false,
  eventInfo: [],
};

export default DaajiMessageAudio;
